import type { RouteRecordRaw } from 'vue-router';

export const leaveCalendarRoutes: RouteRecordRaw[] = [
  {
    path: 'leavemanagement/calendar',
    name: 'LeaveCalendarList',
    component: () => import('../components/LeaveCalendarList.vue'),
    meta: {
      title: 'Leave Calendar',
      requiresAuth: true,
      permissions: ['leave.calendar.view']
    }
  },
     {
    path: 'leavemanagement/leavecalendar/View',
    name: 'LeaveCalendarView',
    component: () => import('../components/LeaveCalendarView.vue'),
    meta: {
      title: 'Leave Calendar',
      requiresAuth: true,
      permissions: ['leave.calendar.view']
    }
  },
  //  {
  //   path: 'leavemanagement/calendar',
  //   name: 'LeaveCalendar',
  //   component: () => import('../components/LeaveCalendarView.vue'),
  //   meta: {
  //     title: 'Leave Calendar',
  //     requiresAuth: true,
  //     permissions: ['leave.calendar.view']
  //   }
  // },
  {
    path: 'leavemanagement/leavecalendar/Form',
    name: 'LeaveCalendarForm',
    component: () => import('../components/LeaveCalendarForm.vue'),
    meta: {
      title: 'Leave Calendar',
      requiresAuth: true,
      permissions: ['leave.calendar.view']
    }
  },
  {
    path: 'leavemanagement/leavecalendar/:Id/edit',
    name: 'LeaveCalendarEditForm',
    component: () => import('../components/LeaveCalendarForm.vue'),
    meta: {
      title: 'Leave Calendar',
      requiresAuth: true,
      permissions: ['leave.calendar.view']
    }
  },
     
];